/**
 * Product Tabs – Vanilla JS
 * Handles desktop tab switching and keyboard navigation.
 * Mobile uses native <details> accordion (no JS needed).
 */
(function () {
  'use strict';

  function hideFallbackIfWidgetLoaded(container) {
    var fallback = container.querySelector('[data-judgeme-rating-fallback]');
    if (!fallback) return;

    var widget = container.querySelector('.jdgm-review-widget, .jdgm-rev-widg');
    if (!widget) return;

    var hasReviews = widget.querySelector('.jdgm-rev, .jdgm-rev-widg__reviews, .jdgm-rev-widg__header');
    if (hasReviews || widget.textContent.trim().length > 40) {
      fallback.setAttribute('hidden', '');
    }
  }

  function refreshJudgeMeWidgets(container) {
    if (!container) return;

    var widget = container.querySelector(
      '.jdgm-review-widget, .jdgm-rev-widg, .jdgm-widget[data-product-id], [data-widget-name="review_widget"]'
    );
    if (!widget) return;

    var load = function () {
      if (window.jdgm && typeof window.jdgm.loadWidgets === 'function') {
        window.jdgm.loadWidgets();
      }

      document.dispatchEvent(new CustomEvent('jdgm.widgetRefreshed'));
      hideFallbackIfWidgetLoaded(container);
    };

    load();
    window.setTimeout(load, 250);
    window.setTimeout(load, 1000);
  }

  document.querySelectorAll('.product-tabs').forEach(function (container) {
    var nav = container.querySelector('.product-tabs__nav');
    var tabs = nav ? Array.from(nav.querySelectorAll('[role="tab"]')) : [];
    var panels = Array.from(container.querySelectorAll('.product-tabs__panels [role="tabpanel"]'));

    container.querySelectorAll('.product-tabs__mobile-accordion').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        refreshJudgeMeWidgets(details.querySelector('.product-tabs__mobile-body') || details);
      });
    });

    if (tabs.length === 0 || panels.length === 0) return;

    function activateTab(index) {
      tabs.forEach(function (tab, i) {
        var isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function (panel, i) {
        var isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
          refreshJudgeMeWidgets(panel);
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(index);
      });
    });

    nav.addEventListener('keydown', function (event) {
      var currentIndex = tabs.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      var newIndex = currentIndex;

      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          newIndex = (currentIndex + 1) % tabs.length;
          event.preventDefault();
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          event.preventDefault();
          break;
        case 'Home':
          newIndex = 0;
          event.preventDefault();
          break;
        case 'End':
          newIndex = tabs.length - 1;
          event.preventDefault();
          break;
        default:
          return;
      }

      tabs[newIndex].focus();
      activateTab(newIndex);
    });
  });
})();
